import { Component, Input } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import {
  ListPendingInvitationsParams,
  SellerInvitation,
  SellerInvitationsService,
} from 'src/app/core/seller-invitations.service';

@Component({
  selector: 'app-store-details-pending-invitations-data',
  templateUrl: './store-details-pending-invitations-data.component.html',
  styleUrls: ['./store-details-pending-invitations-data.component.scss'],
})
export class StoreDetailsPendingInvitationsDataComponent {
  @Input() store_id?: string | null;
  is_list_running: boolean = true;
  invitations?: SellerInvitation[];
  cursor: string | null = null;
  filters?: ListPendingInvitationsParams;

  constructor(private seller_service: SellerInvitationsService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.invitations = [];
    this.cursor = null;
    if (this.store_id) {
      this.filters = { store_id: this.store_id };
      this.listPendingInvitations(this.filters);
    }
  }

  onRefresh(): void {
    this.invitations = [];
    this.cursor = null;
    if (this.store_id) {
      this.filters = { store_id: this.store_id };
      this.listPendingInvitations(this.filters);
    }
  }

  listPendingInvitations(filters?: ListPendingInvitationsParams): void {
    console.log('listPendingInvitations', filters);

    const list_steps_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.seller_service.listPendingInvitations(list_steps_params).subscribe({
      next: response => {
        const invitations = response.data.data;
        this.invitations = (this.invitations ? this.invitations : []).concat(invitations);
        this.cursor = response.data.cursor;
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.error_service.processApiError(processed_error.code, processed_error.message);
        this.is_list_running = false;
      },
    });
  }
}
